import postPortalJson from '../../js/PortalPostJson'
import putPortalJson from '../../js/PortalPutJson'
import { TO_LEAD_MODEL, TO_LEAD_ADDRESS_MODEL, TO_LEAD_CALLCENTER_MODEL } from '../../js/ModelHelpers.js'

const state = () => ({
  firstname: null,
  lastname: null,
  email: null,
  phone1: null,
  media_type: 'callcenter',
  birthDay: null,
  birthMonth: null,
  birthYear: null,
  gender: null,
  test: false,
  ip: null,
  address: null,
  address2: null,
  zip: null,
  city: null,
  state: null,
  errors: {},
  extraData: {
    leadId: null,
    addressId: null
  }
})

const getters = {
  leadInfo: (state) => {
    return { ...state }
  },
  isSaved: (state) => {
    return state.extraData.leadId !== null && state.extraData.addressId !== null
  },
  hasErrors: (state) => {
    return Object.keys(state.errors).length > 0
  }
}

async function saveCallCenter (ccModel) {
  var errors = {}
  var ccResults = null
  try {
    ccResults = await postPortalJson('lead_call_centers', { lead_call_center: ccModel.callcenter })
    if (ccResults.errors !== undefined) {
      Object.keys(ccResults.errors).forEach((key) => { errors[key] = ccResults.errors[key][0] })
    }

    return {
      isSuccess: ccResults.errors === undefined,
      errors: errors
    }
  } catch {
    Object.keys(ccResults.errors).forEach((key) => { errors[key] = ccResults.errors[key][0] })
    return {
      errors: errors,
      isSuccess: false
    }
  }
}

const actions = {
  async save ({ commit, state }, consumerId) {
    var errors = {}
    var ignoredFields = ['service_leadid',
      'source_service_leadid',
      'source_service_trusted_form',
      'service_trusted_form',
      'signup_url',
      'consent_url',
      'warning',
      'address2']
    Object.keys(state).forEach((key) => {
      if (!ignoredFields.includes(key) && (state[key] === null || state[key] === '')) {
        errors[key] = 'is required'
      }
    })
    if (Object.keys(errors).length > 0) {
      commit('setField', { field: 'errors', value: errors })
      return
    }
    var leadResults = null
    var leadModel = TO_LEAD_MODEL(state)
    leadModel.lead.consumer_id = consumerId
    leadModel.lead.dob = `${state.birthYear}-${state.birthMonth > 9 ? state.birthMonth : '0' + state.birthMonth}-${state.birthDay > 9 ? state.birthDay : '0' + state.birthDay}`
    commit('setField', { field: 'dob', value: leadModel.lead.dob })
    try {
      if (state.extraData.leadId !== null) {
        leadResults = await putPortalJson(`leads/${state.extraData.leadId}`, { lead: leadModel.lead })
      } else {
        leadResults = await postPortalJson('leads', { lead: leadModel.lead })
        commit('setLeadId', leadResults.lead.id)
        var ccModel = TO_LEAD_CALLCENTER_MODEL(leadModel.otherFields)
        ccModel.callcenter.lead_id = leadResults.lead.id
        var ccResults = await saveCallCenter(ccModel)
        if (!ccResults.isSuccess) {
          commit('setField', { field: 'errors', value: ccResults.errors })
          return
        }
      }
    } catch {
      Object.keys(leadResults.errors).forEach((key) => { errors[key] = leadResults.errors[key][0] })
      commit('setField', { field: 'errors', value: errors })
      return
    }

    if (leadResults.errors) {
      Object.keys(leadResults.errors).forEach((key) => { errors[key] = leadResults.errors[key][0] })
      commit('setField', { field: 'errors', value: errors })
      return
    }

    var addressResults = null
    var addressModel = TO_LEAD_ADDRESS_MODEL(leadModel.otherFields)
    addressModel.address.lead_id = leadResults.lead.id
    try {
      if (state.extraData.addressId) {
        addressResults = await putPortalJson(`lead_addresses/${state.extraData.addressId}`, { lead_address: addressModel.address })
      } else {
        addressResults = await postPortalJson('lead_addresses', { lead_address: addressModel.address })
        commit('setAddressId', addressResults.lead_address.id)
      }
    } catch {
      Object.keys(addressResults.errors).forEach((key) => { errors[key] = addressResults.errors[key][0] })
      commit('setField', { field: 'errors', value: errors })
      return
    }

    if (addressResults.errors) {
      Object.keys(addressResults.errors).forEach((key) => { errors[key] = addressResults.errors[key][0] })
      commit('setField', { field: 'errors', value: errors })
      return
    }
    commit('setField', { field: 'errors', value: errors })
  },
  async loadData ({ commit }, leadData) {
    var lead = TO_LEAD_MODEL(leadData.lead)
    var birthDate = new Date(lead.lead.dob)
    lead.lead.birthDay = birthDate.getDate() + 1
    lead.lead.birthMonth = birthDate.getMonth() + 1
    lead.lead.birthYear = birthDate.getFullYear()
    var address = TO_LEAD_ADDRESS_MODEL(leadData.address)
    commit('setState', lead.lead)
    commit('setState', address.address)
    commit('setLeadId', leadData.lead.id)
    commit('setAddressId', leadData.address.id)
  }
}

const mutations = {
  setState (state, newState) {
    Object.keys(newState).forEach((k) => { if (typeof newState[k] !== 'undefined') { state[k] = newState[k] } })
  },
  setField (state, fieldUpdate) {
    state[fieldUpdate.field] = fieldUpdate.value
    if (fieldUpdate.field === 'firstname' || fieldUpdate.field === 'lastname') {
      state.fullname = state.firstname + ' ' + state.lastname
    }
    delete state.errors[fieldUpdate.field]
  },
  setLeadId (state, leadId) {
    state.extraData.leadId = leadId
  },
  setAddressId (state, addressId) {
    state.extraData.addressId = addressId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
